// Checkout contact details (PLAN_GUEST_CHECKOUT G-P3). Remembered per browser
// so a returning guest does not retype them; members are prefilled from
// /auth/me instead.

export interface Contact { name: string; email: string; phone: string; }

const KEY = 'sf.contact';

export function loadContact(): Contact {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return { name: '', email: '', phone: '' };
    const p = JSON.parse(raw) as Partial<Contact>;
    return { name: String(p.name || ''), email: String(p.email || ''), phone: String(p.phone || '') };
  } catch { return { name: '', email: '', phone: '' }; }
}

export function saveContact(c: Contact): void {
  try { window.localStorage.setItem(KEY, JSON.stringify(c)); } catch { /* private mode */ }
}
